<mat-select [placeholder]="placeholder" [(ngModel)]="value" [disabled]="disabled">
  <mat-option *ngFor="let client of _clients" [value]="client">{{ client }}</mat-option>
</mat-select>
